import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import LeadCard from './LeadCard';

interface Lead {
  id: string;
  name: string;
  email?: string;
  phone?: string;
  company?: string;
  value?: number;
  status: string;
  lead_source: string;
  notes?: string;
  last_contact_date?: string;
  next_follow_up?: string;
  created_at: string;
  updated_at: string;
  tags?: string[];
}

interface SortableLeadCardProps {
  lead: Lead;
  onEdit?: (lead: Lead) => void;
  onAddNote?: (leadId: string) => void;
  onScheduleFollowUp?: (leadId: string) => void;
  onViewDetails?: (lead: Lead) => void;
}

const SortableLeadCard: React.FC<SortableLeadCardProps> = (props) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({
    id: props.lead.id,
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      {...attributes}
      {...listeners}
      className={isDragging ? 'cursor-grabbing' : 'cursor-grab'}
    >
      <LeadCard {...props} />
    </div>
  );
};

export default SortableLeadCard;